import { c as _c } from "react/compiler-runtime";
import './recurring-giving-options.scss';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import { RadioGroup } from '@sola/ark-core/molecules/radio-group/radio-group.tsx';
import { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { sortCommitmentsByPriority } from '@sola/supporter-sdk/utils/commitments.ts';
import { CommitmentAvatarGroup } from '../../molecules/commitment-avatar-group/commitment-avatar-group.tsx';
export enum RecurringGivingRadioOptionsEnum {
  Yes = 'Yes',
  No = 'No',
}
export type RecurringGivingOptionsProps = {
  commitments: GraphQLCommitment[];
};
export const RecurringGivingOptions: React.FC<RecurringGivingOptionsProps> = t0 => {
  const $ = _c(57);
  const {
    commitments
  } = t0;
  const {
    t
  } = useTranslation("my");
  const [recurringGivingSelection, setRecurringGivingSelection] = useState("");
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== commitments || $[1] !== t) {
    const sortedCommitments = sortCommitmentsByPriority(commitments, t);
    t8 = "w-full flex flex-col gap-comfy-md";
    T1 = Alert;
    t5 = "warning";
    if ($[12] !== t) {
      t6 = t("addPaymentMethod.recurringGiving.alert.title");
      $[12] = t;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    if ($[14] !== t) {
      t7 = t("addPaymentMethod.recurringGiving.alert.message");
      $[14] = t;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    T0 = CommitmentAvatarGroup;
    t1 = sortedCommitments;
    t2 = "lg";
    t3 = 4;
    t4 = t("addPaymentMethod.recurringGiving.alert.tooltip", {
      count: sortedCommitments.length
    });
    $[0] = commitments;
    $[1] = t;
    $[2] = T0;
    $[3] = T1;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    T0 = $[2];
    T1 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
  }
  let t9;
  if ($[16] !== T0 || $[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4) {
    t9 = <T0 commitments={t1} size={t2} itemsToShow={t3} tooltipMessage={t4} />;
    $[16] = T0;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== T1 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t9) {
    t10 = <T1 variant={t5} title={t6} message={t7} footer={t9} />;
    $[22] = T1;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t) {
    t11 = t("addPaymentMethod.recurringGiving.radioGroup.title");
    $[28] = t;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = e => {
      setRecurringGivingSelection(e.target.value);
    };
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t) {
    t13 = t("addPaymentMethod.recurringGiving.radioGroup.actions.yes");
    $[31] = t;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t13) {
    t14 = <span>{t13}</span>;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t) {
    t15 = t("addPaymentMethod.recurringGiving.radioGroup.buttonMessage");
    $[35] = t;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t15) {
    t16 = <span className="RecurringGivingOptions__radio-subtitle label-moderate label-md">{t15}</span>;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t14 || $[40] !== t16) {
    t17 = {
      value: RecurringGivingRadioOptionsEnum.Yes,
      element: <span className="flex flex-col flex-wrap">{t14}{t16}</span>
    };
    $[39] = t14;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t) {
    t18 = t("addPaymentMethod.recurringGiving.radioGroup.actions.no");
    $[42] = t;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t18) {
    t19 = {
      text: t18,
      value: RecurringGivingRadioOptionsEnum.No
    };
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t17 || $[47] !== t19) {
    t20 = [t17, t19];
    $[46] = t17;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== recurringGivingSelection || $[50] !== t11 || $[51] !== t20) {
    t21 = <div><RadioGroup required={true} label={t11} variant="boxed" name="recurringGiving" value={recurringGivingSelection} onChange={t12} items={t20} /></div>;
    $[49] = recurringGivingSelection;
    $[50] = t11;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== t10 || $[54] !== t21 || $[55] !== t8) {
    t22 = <div className={t8}>{t10}{t21}</div>;
    $[53] = t10;
    $[54] = t21;
    $[55] = t8;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  return t22;
};